import {useAppSelector} from "@Hooks/selector/useAppSelector";

export default function useCurrency() {
    return useAppSelector((state) => state?.searchResults.currency)
}